import request from '@/utils/request'

export function getCeoCheckList (params, isProgress) {
  return request({
    url: `/api/getCeoCheckList`,
    method: 'POST',
    meta: { apiVersion: '1.0.0' },
    data: params,
    headers: { 'Content-Type': 'application/json;charset=utf8' },
    Notify: { use: isProgress, apitype: 'searched' },
  })
}